<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperInventoryRequestsMaterialsAndEquipments',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'inventoryRequestsMaterialsAndEquipmentsModule',
    };
  },
};
</script>
